// src/components/Options.js
import React, { useState } from 'react';
import './options.css';
import { useDispatch, useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import html2canvas from 'html2canvas';
import ExportDeck from '../Exportdeck';
import Deck from '../Deck';
import base from '../../res/base.jpg';
import ExportImageButton from '../ExportImageButton';

const Options = ({ deckRef }) => {
    const dispatch = useDispatch();
    const [menuOpen, setMenuOpen] = useState(false);

    const mainDeck = useSelector((state) => state.deck?.main || []);
    const groupedByType = useSelector((state) => state.deck?.groupedByType || []);
    const goldCurve = useSelector((state) => state.deck?.goldCurve || []);

    const deckBuilder = () => {
        let deckFileToDownload = '#main\n';
        mainDeck.forEach((card) => {
            deckFileToDownload += `${card.Nombre} x${card.quantity}\n`;
        });
        fileDownload(deckFileToDownload, 'deck.txt', 'application/octet-stream');
    };

    const handleScreenshot = async () => {
        if (!deckRef || !deckRef.current) {
            console.error("deckRef is not available");
            return;
        }

        try {
            const canvas = await html2canvas(deckRef.current);
            const imgURL = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.href = imgURL;
            link.download = "deck_screenshot.png";
            link.click();
        } catch (error) {
            console.error("Error capturing screenshot:", error);
        }
    };
    
    // ✅ Nuevo handler para click
        const handleButtonClick = (e, callback) => {
            if (callback) {
                callback();
            }
            if (window.innerWidth <= 768) {
                e.currentTarget.blur();
            }
        };
    
    return (
        <>
            <button
                className="menu-toggle"
                onClick={(e) =>
                    handleButtonClick(e, () => setMenuOpen(!menuOpen))
                }
            >
                ☰
            </button>

            <div className={`options-container ${menuOpen ? 'open' : ''}`}>
                <div className="options-background"></div>

                <div className="exportdeck">
                    <ExportDeck />
                </div>

                <div className="options">
                    <button
                        className="btn-erase"
                        onClick={(e) =>
                            handleButtonClick(e, () => {
                                dispatch({ type: 'ERASE_DECK' }); // ✅ Ahora es una callback de verdad
                            })
                        }
                    >
                        Borrar
                    </button>

                    <div className={`other-component ${menuOpen ? 'open' : ''}`} >
                        <ExportImageButton 
                            groupedMainDeck={groupedByType || {}}  
                            goldCurve={goldCurve || {}}
                            base={base}
                        />
                    </div>
                </div>
            </div>

            <Deck menuOpen={menuOpen} />
        </>
    );
};

export default Options;

